export default "__VITE_ASSET__DqNOOOJt__"